/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { PropValuesEnum, joiningSteps } from "../../constants/commons";
import { ResponsiveWidget, ResponsiveWidgetItem } from "../ResponsiveWidget";
import { useIsMobile } from "../../hooks/useIsMobile";
import { joiningStepsStyle } from "./styles";

interface JoiningStepsProps {
  heading: string;
}

export const JoiningSteps: React.FunctionComponent<JoiningStepsProps> = (
  props
) => {
  const { heading } = props;
  const isMobile = useIsMobile();
  const getJoiningSteps = () => {
    return joiningSteps.map((item, key) => {
      return (
        <ResponsiveWidgetItem key={key}>
          <div className="img-container">
            <img src={require(`../../assets/${item.icon}`)} alt="" />
          </div>
          <div className="text-container">{item.description}</div>
        </ResponsiveWidgetItem>
      );
    });
  };

  return (
    <React.Fragment>
      <div className="header-container mb-4">
        <h5>{heading}</h5>
      </div>
      <ResponsiveWidget
        align={isMobile ? PropValuesEnum.VERTICAL : PropValuesEnum.HORIZONTAL}
        className="data-container"
        css={joiningStepsStyle(isMobile ? true : false)}
      >
        {getJoiningSteps()}
      </ResponsiveWidget>
    </React.Fragment>
  );
};
